import { Logo } from '@/components/Logo';

/**
 * Full-screen splash shown while the session is being restored on app load
 * (e.g. Cognito silently refreshing tokens). Keeps guards from flashing the
 * login screen for authenticated users during the brief bootstrap.
 */
export function AuthSplash() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-5 bg-surface-muted">
      <Logo className="h-8" />
      <span
        className="h-7 w-7 animate-spin rounded-full border-2 border-border-strong border-t-brand-accent"
        aria-hidden="true"
      />
      <p className="text-sm text-text-muted">Cargando tu sesión…</p>
    </div>
  );
}
